import "regenerator-runtime/runtime";
import { datadogRum } from "@datadog/browser-rum";
import TelemetryProvider from "../telemetryProvider";

class TelemetryDatadogRUM extends TelemetryProvider {
  constructor() {
    super();

    if (!TelemetryDatadogRUM.instance) {
      TelemetryDatadogRUM.instance = this;
      this.initRum();
    }

    return TelemetryDatadogRUM.instance;
  }

  initRum() {
    // `telemetryConfig` comes from the JADE template in a global var

    try {
      datadogRum.init(window.telemetryConfig.datadogRUMConfig);
      this.ddInstance = datadogRum;
    } catch (err) {
      console.error(
        `Datadog RUM error on initialization ${JSON.stringify(err.message)}`
      );
    }
  }

  info(title = "", properties = {}) {
    this.ddInstance && this.ddInstance.addAction(title, properties);
  }

  error(title = "", properties = {}) {
    this.ddInstance && this.ddInstance.addError(title, properties);
  }
}

export default TelemetryDatadogRUM;



// WEBPACK FOOTER //
// ./client/src/telemetry/providers/telemetryDatadogRUM.js